export default __webpack_public_path__ + "static/media/MEGAFONE.860150ff.svg";